/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const addToCart = (items) => {
	const body = {
		items: [...items]
	}
	fetch(`${window.routes.cartAddUrl}.js`, {
		body: JSON.stringify(body),
		credentials: 'same-origin',
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		}
	})
	.then(response => {
		if (response.ok) {
			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
				bubbles: true
			}));
			document.documentElement.dispatchEvent(new CustomEvent('cart:open', {
				bubbles: true
			}));
		} else {
			response.json().then(content => {
				console.error(content['description'])
			})
		}
	})
}

document.addEventListener('DOMContentLoaded', () => {
	/**
	 * SECTION TABS
	 */
	const tabSections = document.querySelectorAll('.SectionTabs');
	if (tabSections.length) {
		tabSections.forEach((section) => {
			const tabToggleButtons = section.querySelectorAll('[data-tab-toggle]');
			const tabs = section.querySelectorAll('[data-tab]');
	
			if (!tabToggleButtons.length || !tabs.length) return;
	
			tabToggleButtons.forEach(button => button.addEventListener('click', () => {
				tabToggleButtons.forEach(button => button.classList.remove('Active'));
	
				const targetTab = button?.dataset?.tabToggle;
				button.classList.add('Active')
	
				tabs.forEach(tab => {
					const tabName = tab?.dataset?.tab;
	
					if (targetTab === tabName) {
						tab.hidden = false;
						return
					}
	
					tab.hidden = true;
				})
			}))
		})
	}


	/**
	 * FOOTER NAV TABS
	 */
	const footerNavToggles = document.querySelectorAll('[data-footer-nav-toggle]');
	if (footerNavToggles.length) {
		footerNavToggles.forEach(navToggle => navToggle.addEventListener('click', () => {
			const linkList = navToggle.nextElementSibling;
				if (linkList.matches('.Linklist')) {
					const state = linkList.getAttribute('aria-hidden') === 'true';
					linkList.setAttribute('aria-hidden', !state);
				}
			})
		)
	}

	/**
	 * CART UPSELLS
	 */
	document.addEventListener('click', (event) => {
		/**
		 * Dropdown
		 */
		if (event.target.closest('.CartUpsell__Header')) {
			const cartUpsell = event.target.closest('.CartUpsell');
			const cartUpsellContent = cartUpsell.querySelector('.CartUpsell__Content');
	
			cartUpsellContent.hidden = !cartUpsellContent.hidden;
		}

		/**
		 * Add to cart
		 */
		 if (event.target.closest('[data-action="upsell-add-to-cart"]')) {
			const addToCartButton = event.target.closest('[data-action="upsell-add-to-cart"]');
			const upsellSelect = addToCartButton.parentElement.querySelector('[name="id"]')

			if (upsellSelect) {
				const id = parseInt(upsellSelect.value);
				addToCart([{
					id,
					quantity: 1
				}])
				
			}
		 }

	})

	const descriptionExpandButton = document.querySelector('[data-expand-description]');
	if (descriptionExpandButton) {
		descriptionExpandButton.addEventListener('click', () => {
			const state = descriptionExpandButton.previousElementSibling.getAttribute('aria-expanded');
			const newState = state === 'true' ? 'false' : 'true';
			descriptionExpandButton.previousElementSibling.setAttribute('aria-expanded', newState);
			descriptionExpandButton.textContent = newState === 'false' ? window?.languages?.readMore : window?.languages?.readLess;
		})
	}


	// SIZE GUIDE DRAWER
	const sizeGuideDrawerButtonOpen = document.querySelector('[data-size-drawer-open]');
	const sizeGuideDrawerButtonClose = document.querySelector('[data-size-drawer-close]');
	const sizeGuideDrawer = document.querySelector('.Drawer--sizeGuide');
	if (sizeGuideDrawerButtonOpen && sizeGuideDrawer) {
		const pageOverlay = document.querySelector('.PageOverlay');

		const closeSizeDrawer = (e) => {
			sizeGuideDrawer.setAttribute('aria-hidden', 'true');
			document.documentElement.classList.remove('no-scroll')
			if (pageOverlay) pageOverlay.classList.remove('is-visible');
		}
		
		const openSizeDrawer = () => {
			sizeGuideDrawer.setAttribute('aria-hidden', 'false');
			document.documentElement.classList.add('no-scroll')
			if (pageOverlay) pageOverlay.classList.add('is-visible');
		}
		if (pageOverlay) {
			pageOverlay.addEventListener('click', closeSizeDrawer)
		}
		if (sizeGuideDrawerButtonClose) {
			sizeGuideDrawerButtonClose.addEventListener('click', closeSizeDrawer)
		}
		sizeGuideDrawerButtonOpen.addEventListener('click', openSizeDrawer);
	}
});

$(document).ready(function(){
  let read_more = document.getElementById('read-more')
  let read_less = document.getElementById('read-less');
  let truncated_description = document.getElementById('truncated-product-description');
  let full_description = document.getElementById('product-description');

  if (read_more !== null) {
    read_more.addEventListener('click', showHideDescription)
  }

  if (read_less !== null) {
    read_less.addEventListener('click', showHideDescription)
  }
  
  
  function showHideDescription(){
    let ID = this.id
    if(ID === "read-more"){
      truncated_description.style.display = "none";
      full_description.style.display = "block";
    }else {
      truncated_description.style.display = "block";
      full_description.style.display = "none";    
    }
  }


  $('.product-image-with-title-slider').flickity({
    "prevNextButtons": false,
    "pageDots": true,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center",
    "groupCells": true,
    "lazyLoad": 1,
    "watchCSS": true,
    "imagesLoaded": true
  });

  $(window).scroll(function(){
      $('.product-image-with-title-slider').flickity('resize');
  });
   

  if(window.outerWidth < 1008) {
  

  $('.Product__Slideshow').flickity({
      prevNextButtons: false,
      pageDots: false,
      wrapAround: false,
      contain: true,
      groupCells: false
  });
  
  $('.Product__SlideshowNavScroller').flickity({
    asNavFor: '.Product__Slideshow',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
  });

  }

  
});

//Chart activate when in viewport

    // Function to handle the intersection observer callback
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        } else {
          entry.target.classList.remove("active");
        }
      });
    };

    // Function to set up the intersection observer for each .chart element
    const setupIntersectionObserver = () => {
      const chartElements = document.querySelectorAll(".chart");
      chartElements.forEach(chart => {
        const chartObserver = new IntersectionObserver(handleIntersection, {
          root: null,
          rootMargin: "0px",
          threshold: 0.5, // Adjust this threshold value based on your needs
        });

        chartObserver.observe(chart);
      });
    };

    // Call the setupIntersectionObserver function to start observing
    setupIntersectionObserver();

    // Function to handle screen resize
    const handleResize = () => {
      const chartElements = document.querySelectorAll(".chart");
      chartElements.forEach(chart => {
        const chartObserver = new IntersectionObserver(handleIntersection, {
          root: null,
          rootMargin: "0px",
          threshold: 0.5, // Adjust this threshold value based on your needs
        });

        chartObserver.unobserve(chart);
        chartObserver.observe(chart);
      });
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);


// toggle temp
  document.addEventListener("DOMContentLoaded", function() {
    var toggleButtons = document.querySelectorAll(".tempToggleButton");
    for (var i = 0; i < toggleButtons.length; i++) {
      toggleButtons[i].addEventListener("click", function() {
        var toggleElements = document.querySelectorAll(".tempToggleButton, .tempScaleNumbersDeg");
        for (var j = 0; j < toggleElements.length; j++) {
          toggleElements[j].classList.toggle("active");
        }
      });
    }
  });

// REBUY DRAWER IMPLEMENTATION

// Function to apply the discount based on the class
function applyDiscount(product, discountPercentage) {
    let priceElement = product.querySelector('.rebuy-money');
    let originalPriceText = priceElement.textContent.trim().replace(/[^0-9.]/g, '');
    let originalPrice = parseFloat(originalPriceText);

    if (!isNaN(originalPrice)) {
        let salePrice = (originalPrice * (1 - discountPercentage / 100)).toFixed(2);
        
        let salePriceElement = document.createElement('span');
        salePriceElement.textContent = `$${salePrice}`;
        salePriceElement.style.color = 'red';
        salePriceElement.style.marginRight = '5px';

        priceElement.style.textDecoration = 'line-through';
        priceElement.style.marginLeft = '5px';

        // Avoid adding multiple sale prices if DOM refreshes multiple times
        if (!priceElement.parentNode.querySelector('.sale-price')) {
            salePriceElement.classList.add('sale-price');
            priceElement.parentNode.insertBefore(salePriceElement, priceElement);
        }
    }
}

// Function to apply discounts to products
function applyDiscountsToProducts() {
    document.querySelectorAll('.tag-sale20, .tag-sale30, .tag-sale40, .tag-sale50, .tag-sale60').forEach(function(product) {
        let discountPercentage = 0;

        if (product.classList.contains('tag-sale20')) discountPercentage = Math.max(discountPercentage, 20);
        if (product.classList.contains('tag-sale30')) discountPercentage = Math.max(discountPercentage, 30);
        if (product.classList.contains('tag-sale40')) discountPercentage = Math.max(discountPercentage, 40);
        if (product.classList.contains('tag-sale50')) discountPercentage = Math.max(discountPercentage, 50);
        if (product.classList.contains('tag-sale60')) discountPercentage = Math.max(discountPercentage, 60);

        if (discountPercentage > 0) {
            applyDiscount(product, discountPercentage);
        }
    });
}

// Initiate Rebuy Cart Drawer Widget and apply discounts
var initRebuy = () => {
    Rebuy.init();
    applyDiscountsToProducts();
};

// Mutation Observer to watch for DOM changes in the cart
const targetNode = document.querySelector('body'); // Adjust this to a more specific target if possible
const config = { childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
    for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Apply discounts when changes are detected
            applyDiscountsToProducts();
        }
    }
};

// Create an instance of MutationObserver and pass the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);

// Listen for Rebuy cart changes and reinitialize Rebuy
document.addEventListener('rebuy:cart.change', function(event) {
    initRebuy();
});

// Initiate Rebuy Cart Drawer Widget and apply discounts
var initRebuy = () => {
    setTimeout(function(){
        Rebuy.init();
        // Apply discounts to products after Rebuy initializes
        applyDiscountsToProducts();
    }, 500);
};


// Force only in stock items to show on collection pages

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('collection-filters-sidebar-form');
    const inStockCheckbox = document.getElementById('sidebar-filter-v-availability1');

    if (!form || !inStockCheckbox) return;

    form.addEventListener('change', function(event) {
        if (event.target.name !== 'filter.v.availability' && !inStockCheckbox.checked) {
            inStockCheckbox.checked = true;
        }
    });
});

// End Force only in stock items to show -->
